export default "\nfloat scalarize(in vec4 h) {\n    return h.x;\n}\n";